import { render, staticRenderFns } from "./usagRecordLists.vue?vue&type=template&id=ddb2c738&scoped=true&"
import script from "./usagRecordLists.vue?vue&type=script&lang=js&"
export * from "./usagRecordLists.vue?vue&type=script&lang=js&"
import style0 from "./usagRecordLists.vue?vue&type=style&index=0&id=ddb2c738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb2c738",
  null
  
)

export default component.exports